module.exports = __webpack_public_path__ + "img/FR.78e9f99b.png";